/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as RoomingPerDayDataStoreActions from './rooming-per-day-data-store.actions';

import { RoomingPerDay } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'RoomingPerDayDataStore';

/* State interface */
export interface RoomingPerDayState {
  isLoading?: boolean;
  roomingPerDays?: RoomingPerDay[];
  activeRoomingPerDay?: RoomingPerDay;
}

/* Initial values */
export const initialState: RoomingPerDayState = {
  isLoading: null,
  roomingPerDays: null,
  activeRoomingPerDay: null,
};

export const reducer = createReducer(
  initialState,
  on(RoomingPerDayDataStoreActions.GetRoomingPerDays, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    RoomingPerDayDataStoreActions.GetRoomingPerDaysSuccessful,
    (state, action) => ({
      ...state,
      roomingPerDays: action.payload.roomingPerDays,
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.GetRoomingPerDaysFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(RoomingPerDayDataStoreActions.GetRoomingPerDayById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    RoomingPerDayDataStoreActions.GetRoomingPerDayByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.GetRoomingPerDayByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.GetActiveRoomingPerDayWithRelationsById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.GetActiveRoomingPerDayByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeRoomingPerDay: action.payload.activeRoomingPerDay,
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.GetActiveRoomingPerDayByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(RoomingPerDayDataStoreActions.CreateRoomingPerDay, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    RoomingPerDayDataStoreActions.CreateRoomingPerDaySuccessful,
    (state, action) => ({
      ...state,
      roomingPerDays: [
        ...(state.roomingPerDays ?? []),
        action.payload.roomingPerDay,
      ],
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.CreateRoomingPerDayFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(RoomingPerDayDataStoreActions.UpdateRoomingPerDay, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    RoomingPerDayDataStoreActions.UpdateRoomingPerDaySuccessful,
    (state, action) => ({
      ...state,
      roomingPerDays: updateEntityInArray<RoomingPerDay>(
        action.payload.id,
        action.payload.data,
        state.roomingPerDays ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.UpdateRoomingPerDayFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(RoomingPerDayDataStoreActions.DeleteRoomingPerDay, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    RoomingPerDayDataStoreActions.DeleteRoomingPerDaySuccessful,
    (state, action) => ({
      ...state,
      roomingPerDays:
        state.roomingPerDays?.filter((item) => action.payload.id !== item.id) ??
        [],
      isLoading: false,
    }),
  ),

  on(
    RoomingPerDayDataStoreActions.DeleteRoomingPerDayFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(RoomingPerDayDataStoreActions.ResetState, () => initialState),
);
